import * as S from '../style';

export default function S3ImagePopUp({ ...props }: { setS3Image: any; s3Image: string }) {
  if (!props.s3Image) return <></>;
  return (
    <S.S3ImageContainer>
      <S.S3ImageBox>
        <S.S3ImageExitButton
          onClick={() => {
            props?.setS3Image('');
          }}
        />
        <S.S3Image src={props?.s3Image} />
      </S.S3ImageBox>
    </S.S3ImageContainer>
  );
}
